import request from '../request';

export const getAllSSO = () => 
  request.get('setting/sso').then((res) => res)

export const createSSO = (data) =>
  request.post('setting/sso', data).then((res) => res)

export const updateSSO = (id, data) =>
  request.put(`setting/sso/${id}`, data).then((res) => res)

export const deleteSSO = (id) =>
  request.delete(`setting/sso/${id}`).then((res) => res)
